import React from 'react';
import { FunnelCard } from '../components/FunnelCard';
import { StatCard } from '../components/StatCard';
export function Reports() {
  return <div className="space-y-4" data-id="element-375" data-mp="175wxsanurv6w">
      <div data-id="element-376" data-mp="1c4q51lcjqpym">
        <h1 className="text-[22px] font-bold text-ink" data-id="element-377" data-mp="1c46w2u4vjbwq">Reports</h1>
        <p className="mt-1 text-[13px] text-gray-500" data-id="element-378" data-mp="1c72tmhct7ykn">
          Your performance · last 30 days
        </p>
      </div>

      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 xl:grid-cols-4" data-id="element-379" data-mp="1m35tfgk6vl4f">
        <StatCard label="Assigned" value="128" caption="leads routed to you" data-id="element-380" data-mp="1m13654af863e" />
        <StatCard label="Contact rate" value="78%" caption="100 of 128 reached" data-id="element-381" data-mp="1q2of4eju408b" />
        <StatCard label="Engaged" value="52" caption="active conversations" data-id="element-382" data-mp="1uwitr3kl1p0j" />
        <StatCard label="Converted" value="22" caption="17.2% of assigned" data-id="element-383" data-mp="1zukd7plx7qcj" />
      </div>

      <FunnelCard data-id="element-384" data-mp="24txbd6i8sjuf" />
    </div>;
}